import * as React from 'react';

import PNRDetailContainer from './components/pnrDetailContainer/PNRDetailContainer';
import AlertModalContainer from '../../components/alertModal/AlertModalContainer';
import LoadMask from '../../components/loadMask';
import { Redirect } from 'react-router-dom';
import MenuBar from '../../components/menuBar/MenuBar';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import PropTypes from 'prop-types';
import './FlightDetailsPage.css';
import pnrToPnrItemModelAssembler from '../../services/detail/PnrToPnrItemModelAssembler';
import * as detailPnrService from '../../services/detail/DetailPnrService';
import * as cancelService from '../../services/cancel/CancelService';
import ModalLoad from '../../components/modalLoad/ModalLoad';
import utils from '../../components/utils/utils';
import '../home/BackGroundImage.css';
import ChangeFlightsMyJourney from '../../components/common/modalChangeFlightMyJourney/ChangeFlightsMyJourney';
import { Status } from '../../const/PNRItemModel';
const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object
};

const defaultProps = {
  showLoading: false
};
export default class FlightDetailsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isRedirect: false,
      urlRedirect: '',
      showLoading: false,
      breadcrumbDetails: false,
      callbackTab:'',
      showModalChangeFlight: false
    };
    window.scroll(0, 0);
    utils.addScroll();
  }

  componentDidMount() {
    this.setState({
      pnrData: this.props.location.state.pnrDataDetail,
      showLoading: false,
      azulNumber: this.props.location.state.azulNumber,
      showModalChangeFlight: this.props.location.state.pnrDataDetail.status === Status.REALLOCATION
    });
  }

  handleCancel = () => {
    this.setState({
      showLoading: true
    });
    detailPnrService.detailPnr(this.state.pnrData.pnrId)
      .then(response => {
        if (response && response.error) throw response;
        this.setState({
          pnrDataDetail: pnrToPnrItemModelAssembler.assemblePnrItemModel(response.data),
        });
        cancelService.simulate(this.state.pnrData.pnrId)
          .then(response => {
            if (response && response.error) throw response;
            this.setState({
              cancelData: response,
              showLoading: false,
              isRedirect: true,
              urlRedirect: 'cancelPnr',
              breadcrumbDetails: true,
              azulNumber: this.state.azulNumber
            });
          })
          .catch(error => {
            this.setState({
              showLoading: false
            });
            utils.addScroll()
            this.showModal(I18n.translate('home.msg.error'));
          });
      })
      .catch(error => {
        this.setState({
          showLoading: false
        });
        utils.addScroll()
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  renderModalLoading() {
    return (
      <ModalLoad
        id="modalLoad"
        showModal={this.state.showLoading}
        ref={c => {
          this.modalLoad = c;
        }}
      />
    );
  }

  handleChangeTrip = () => {
    this.setState({
      isLoading: true
    });

    setTimeout(() => {
      this.setState({
        isLoading: false,
        isRedirect: true,
        urlRedirect: 'flightChangeSelection'
      });
    }, 2000);
  };

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  closeModalChangeFlights = () => {
    this.setState({
      showModalChangeFlight: false
    });
    utils.addScroll();
  };

  callbackTab = (value) => {    
    this.setState({
			callbackTab: value
		}); 
  }

  renderFlightDetails() {
    const { isLoading } = this.state;   
    const afterCancel = this.props.location.state.afterCancel ? this.props.location.state.afterCancel : false;
    return (
      <div className="DetailPNRPage">
        {isLoading && (
          <LoadMask text={I18n.translate('message.checkingChangeAvailable').toString()} />
        )}
        <MenuBar hideChangeSearch={true} callbackTab={this.callbackTab}/>
        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetail'
          ]}
          actual="features.breadcrumb.pnrDetail"
        />
        <div className="body-min-height bg-white padding-eight-36">
          <div className="section__outer">
            {
              this.state.pnrData && (
                <PNRDetailContainer
                  data={this.state.pnrData}
                  afterCancel={afterCancel}
                  refundTaxOnly={false}
                  addPayment={this.addPayment}
                  handleCancel={this.handleCancel}
                  handleChangeTrip={this.handleChangeTrip}
                />
              )}
          </div>
        </div>
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.changeReservation').toString()}
          visible={false}
          closeModal={() => { }}
        />
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.unexpectedServerError').toString()}
          visible={false}
          closeModal={() => { }}
        />
        {this.renderModalLoading()}
        <InfoModal
          id="modalError"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalError = c;
          }}
        />
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                pnrId: this.state.pnrData.pnrId,
                pnrNumber: this.state.pnrData.pnrNumber,
                pnrDataDetail: this.state.pnrDataDetail,
                cancelData: this.state.cancelData,
                breadcrumbDetails: this.state.breadcrumbDetails,
                azulNumber: this.state.azulNumber
              }
            }}
          />
        ) : null}
        <ChangeFlightsMyJourney
          id="modalChangeFlighsMyJourney"
          showModal={this.state.showModalChangeFlight}
          close={this.closeModalChangeFlights}
          ref={c => {
            this.modalChangeFlighsMyJourney = c;
          }}
        />
      </div>
    );
  }

  renderBackgroundLogo(){    
    const { isLoading } = this.state;  
    return (
      <div className="DetailPNRPage">
        {isLoading && (
          <div></div>
        )}
        <MenuBar hideChangeSearch={true} callbackTab={this.callbackTab}/>
        <div className='background-image'>
        </div>       
      </div>
    );
  }

  render() {   
     var renderReturn;
     if(this.state.callbackTab !== "search")
        renderReturn = this.renderFlightDetails()    
      else
        renderReturn = this.renderBackgroundLogo();
     return  renderReturn      
  }


}

FlightDetailsPage.propTypes = propTypes;
FlightDetailsPage.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/FlightDetailsPage.jsx